module.exports = __webpack_public_path__ + "img/4.413e65c0.webp";